import React, { Component } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import {ImagePaths} from '../../../../Utility/ImagePaths';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import Loader from '../../../../Components/Loader';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';

export default class MensuralHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            AgeatMenarche: "",
            AgeatMenopause: "",
            ChildBirthAbortion: "",
            MensuralCycle: "",
        };
    }
    componentDidMount() {
        let clinicId = getCachevalue('SelectedDoctorClinic')
        let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
        this.setState({
            clinicId: clinicId,
            appointmentId: appointmentId?.appointment_id,
            patientId: appointmentId?.patient_id,
            patientDetails: appointmentId
        }, () => {
            this.getPatientDetailData()
            this.getMensuralHistoryData()
        })
    }
    getPatientDetailData = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({
                            patientDetails: {...this.state.patientDetails, ...response?.data?.data}
                        })
                        // this.setupIntersectionObserver()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    getMensuralHistoryData = () => {
        try {
            this.setState({ mensuralloading: true })
            RestAPIService.getAll(Serviceurls.DOC_BLOOD_MENSURAL_HISTORY_GET + `?patient_id=${this.state.patientId}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.setState({ mensuralloading: false })
                        let data = response?.data?.data
                        if (Object.keys(data)?.length > 0) {
                            this.setState({
                                MensuralEdit: true,
                                AgeatMenarche: data?.age_at_menarche ? data?.age_at_menarche : "",
                                AgeatMenopause: data?.age_at_menopause ? data?.age_at_menopause : "",
                                ChildBirthAbortion: data?.child_birth ? data?.child_birth : "",
                                MensuralCycle: data?.mensural_cycle ? data?.mensural_cycle : "",
                                MensuralHistoryID: data?.id ? data?.id : null
                            })
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.setState({ mensuralloading: false })
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.setState({ mensuralloading: false })
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ mensuralloading: false })
            this.errorMessage(error.message)
        }
    }
    postMensuralHistoryData = () => {
        try {
            let data = {
                patient_id: this.state.patientId,
                age_at_menarche: this.state.AgeatMenarche ? Number(this.state.AgeatMenarche) : null,
                age_at_menopause: this.state.AgeatMenopause ? Number(this.state.AgeatMenopause) : null,
                child_birth: this.state.ChildBirthAbortion ? this.state.ChildBirthAbortion : "",
                mensural_cycle: this.state.MensuralCycle ? this.state.MensuralCycle : "",
                menstrual_history_id: this.state.MensuralHistoryID ? this.state.MensuralHistoryID : null
            }
            this.setState({ mensuralloading: true })
            RestAPIService.create(data, Serviceurls.DOC_BLOOD_MENSURAL_HISTORY_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.successMessage(response.data.message)
                        this.onClearMensuralData()
                        this.getMensuralHistoryData()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.setState({ mensuralloading: false })
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.setState({ mensuralloading: false })
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ mensuralloading: false })
            this.errorMessage(error.message)
        }
    }
    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }
    onClearMensuralData = () => {
        try {
            this.setState({
                AgeatMenarche: '',
                AgeatMenopause: '',
                ChildBirthAbortion: '',
                MensuralCycle: '',
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    renderTextBox = (names, value, label, width, disable, len) => {
        try {
            return (
                <TextField
                    size='small'
                    label={label}
                    InputProps={{ readOnly: disable }}
                    sx={{ width: width, mr: '0.5vw', mt: '0.5vw' }}
                    value={value}
                    inputProps={{ maxLength: len ? len : 250 }}
                    name={names}
                    onChange={(e) => this.onChangeHandler(e, names)}
                />
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    render() {
        return (
            <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
                <Box component={'div'} display={'flex'}>
                    <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
                        <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true}/>
                    </Box>
                    {/* <CommonPatientCard details={attender} showDetailed={true} /> */}
                </Box>
                <Box component={'div'} mt={'0.5vw'} height={'61.5vh'} overflow={'scroll'}>
                    <Box id='mensuralHistory' component={'div'} border={'1px solid lightgray'} mb={'1vw'} sx={{ backgroundColor: Colors.white }}>
                        <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'2.5vw'} display={'flex'} justifyContent={'space-between'} pl={'0.5vw'} alignItems={'center'}>
                            <Typography fontSize={'0.9vw'}   fontWeight={600} color={Colors.SecondaryText}>{'History specific for female'}</Typography>
                            {this.state.MensuralEdit ?
                                <Button className='Common_Btn_Min_Width'
                                    onClick={() => this.setState({ MensuralEdit: false })}
                                >
                                    <Box component={'img'} src={ImagePaths.UserEditOn.default} height={'1.5vw'} width={'1.5vw'} />
                                </Button> :
                                <Box display={'flex'}>
                                    <Button variant='contained'
                                        disabled={this.state.phyLoading || !(this.state.AgeatMenarche) || getCachevalue('DoctorUserChanged') === 'true'}
                                        sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                        onClick={() => this.postMensuralHistoryData()}
                                    >Save</Button>
                                    <Button variant='outlined'
                                        sx={{ textTransform: 'capitalize', height: '2vw', width: '5vw', mr: '1vw' }}
                                        onClick={() => this.onClearMensuralData()}
                                    >Clear</Button>
                                </Box>
                            }
                        </Box>
                        {this.state.mensuralloading ?
                            <Box mt={'0.5vw'} mb={'1vw'} ml={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'20vw'}><CircularProgress color='primary' /></Box> :
                            <Box mt={'0.5vw'} mb={'1vw'} ml={'0.5vw'} sx={{ display: "flex", flexDirection: "row" }}>
                                <Box component={'div'} display={'flex'} flexDirection={"column"} justifyContent={'space-between'}  sx={{margin :'2vh 3vw 2vh 1.2vh'}}>
                                    <Box  >
                                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Age at Menarche *'}</Typography>

                                    </Box>
                                    <Box  >
                                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Menstrual cycle'}</Typography>

                                    </Box>
                                    <Box  >
                                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Child birth/abortion'}</Typography>

                                    </Box>
                                    <Box  >
                                        <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{'Age at menopause'}</Typography>

                                    </Box>
                                </Box>
                                <Box component={'div'} display={'flex'} flexDirection={'column'} justifyContent={'space-between'}  marginLeft={'2vw'}>
                                    <Box  >
                                         <TextField
                                            disabled={this.state.MensuralEdit}
                                            size='small'
                                            sx={{ width: '25vw', mr: '0.5vw', mt: '0.5vw' }}
                                            value={this.state.AgeatMenarche}
                                            inputProps={{ maxLength: 2}}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (CommonValidation.numberOnly(value) || value === '' ) {
                                                    this.setState({ AgeatMenarche: value })
                                                }
                                            }}
                                        />
                                    </Box>

                                    <Box  >
                                         <TextField
                                            disabled={this.state.MensuralEdit}
                                            size='small'
                                            sx={{ width: '25vw', mr: '0.5vw', mt: '0.5vw' }}
                                            value={this.state.MensuralCycle}
                                            inputProps={{ maxLength: 150 }}
                                            onChange={(e) => {
                                                this.setState({ MensuralCycle: e.target.value })
                                            }}
                                        />
                                    </Box>

                                    <Box  >
                                         <TextField
                                            disabled={this.state.MensuralEdit}
                                            size='small'
                                            sx={{ width: '25vw', mr: '0.5vw', mt: '0.5vw' }}
                                            value={this.state.ChildBirthAbortion}
                                            inputProps={{ maxLength: 150 }}
                                            onChange={(e) => {
                                                this.setState({ ChildBirthAbortion: e.target.value })
                                            }}
                                        />
                                    </Box>
                                    <Box  >
                                         <TextField
                                            disabled={this.state.MensuralEdit}
                                            size='small'
                                            sx={{ width: '25vw', mr: '0.5vw', mt: '0.5vw' }}
                                            value={this.state.AgeatMenopause}
                                            inputProps={{ maxLength: 2 }}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (CommonValidation.numberOnly(value) || value === '') {
                                                    this.setState({ AgeatMenopause: value })
                                                }
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        }

                    </Box>

                </Box>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader} />
            </Box>

        )
    }
}
